"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var style_1 = require("../../utils/style");
var tooltip_1 = require("../../utils/tooltip");
var propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    alignment: PropTypes.oneOf(['horizontal', 'vertical']),
    colspans: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.number.isRequired),
        PropTypes.shape({
            regular: PropTypes.arrayOf(PropTypes.number),
            medium: PropTypes.arrayOf(PropTypes.number),
            large: PropTypes.arrayOf(PropTypes.number)
        })
    ]),
    boundary: PropTypes.oneOf(['narrow', 'wide'])
};
exports.getNormalizedColspans = function (colspans, elementCount) {
    var spans;
    if (colspans && colspans.length === elementCount) {
        spans = colspans.slice();
    }
    else if (colspans && colspans.length === elementCount + 1) {
        // calculate proportional grow factor of children
        // the rest of the space won't be filled
        var totalColspanSum = colspans.reduce(function (p, c) { return p + c; });
        var shrinkFactor_1 = 1 / totalColspanSum;
        spans = colspans
            .slice(0, colspans.length - 1)
            .map(function (span) { return span * shrinkFactor_1; });
    }
    else {
        // Create an array filled with 1
        // see http://2ality.com/2013/11/initializing-arrays.html
        spans = Array.apply(null, Array(elementCount)).map(function () { return 1; });
    }
    return spans;
};
exports.getColspansConfiguration = function (colspans, elementCount) {
    var colspansConfiguration = {};
    if (colspans && !Array.isArray(colspans)) {
        // apply colspans settings from smaller breakpoints onto all larger screens
        if (colspans.regular) {
            colspansConfiguration.regular = exports.getNormalizedColspans(colspans.regular, elementCount);
            colspansConfiguration.medium = exports.getNormalizedColspans(colspans.regular, elementCount);
            colspansConfiguration.large = exports.getNormalizedColspans(colspans.regular, elementCount);
        }
        if (colspans.medium) {
            colspansConfiguration.medium = exports.getNormalizedColspans(colspans.medium, elementCount);
            colspansConfiguration.large = exports.getNormalizedColspans(colspans.medium, elementCount);
        }
        if (colspans.large) {
            colspansConfiguration.large = exports.getNormalizedColspans(colspans.large, elementCount);
        }
    }
    else {
        // if colspans is specified as an array settings should be applied on the
        // 'large' viewport, which was the previous default
        colspansConfiguration = {
            large: exports.getNormalizedColspans(colspans, elementCount)
        };
    }
    return colspansConfiguration;
};
var FormRowWithinContext = /** @class */ (function (_super) {
    __extends(FormRowWithinContext, _super);
    function FormRowWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.mediumMediaQuery = null;
        _this.largeMediaQuery = null;
        _this.handleMediaEvent = function () {
            var _a = _this.props, colspans = _a.colspans, children = _a.children;
            var countChildren = React.Children.count(children);
            var colspansConfiguration = exports.getColspansConfiguration(colspans, countChildren);
            if (_this.largeMediaQuery && _this.largeMediaQuery.matches) {
                _this.setState({ colspans: colspansConfiguration.large });
            }
            else if (_this.mediumMediaQuery && _this.mediumMediaQuery.matches) {
                _this.setState({ colspans: colspansConfiguration.medium });
            }
            else {
                _this.setState({ colspans: colspansConfiguration.regular });
            }
        };
        var componentId;
        if (React.Children.count(props.children) === 1 &&
            React.Children.toArray(props.children)[0].props) {
            componentId = React.Children.toArray(props.children)[0].props.id;
        }
        _this.id = componentId || props.ergoElements.idGenerator.next();
        _this.groupLabelId = props.ergoElements.idGenerator.next();
        _this.state = {};
        return _this;
    }
    FormRowWithinContext.prototype.componentDidMount = function () {
        // setup media Query to watch for breakpoint change events
        /* istanbul ignore if */
        if (typeof window.matchMedia === 'function') {
            this.mediumMediaQuery = window.matchMedia("(min-width: " + style_1.mediumScreenMinWidth + "px)");
            this.mediumMediaQuery.addListener(this.handleMediaEvent);
            this.largeMediaQuery = window.matchMedia("(min-width: " + style_1.largeScreenMinWidth + "px)");
            this.largeMediaQuery.addListener(this.handleMediaEvent);
            this.handleMediaEvent();
        }
    };
    FormRowWithinContext.prototype.componentWillUnmount = function () {
        /* istanbul ignore if */
        if (typeof window.matchMedia === 'function') {
            this.mediumMediaQuery.removeListener(this.handleMediaEvent);
            this.largeMediaQuery.removeListener(this.handleMediaEvent);
        }
    };
    FormRowWithinContext.prototype.renderChild = function (child, _alignment, spans, index) {
        var itemClass = classNames('ee_form-row__item', "ee_form-row__item--" + this.props.boundary);
        var style = {};
        if (Array.isArray(spans)) {
            var span = spans[index];
            if (span < 1) {
                style = {
                    maxWidth: spans[index] * 100 + "%"
                };
            }
            else {
                itemClass = classNames(itemClass, "ee_form-row__item--span" + span);
            }
        }
        var overrideProps = {};
        if (index === 0) {
            overrideProps.id = this.id;
        }
        return (React.createElement("div", { className: itemClass, style: style },
            React.createElement("div", { className: "ee_form-row__item-container" }, React.cloneElement(child, overrideProps))));
    };
    FormRowWithinContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, children = _a.children, label = _a.label, alignment = _a.alignment, tooltip = _a.tooltip, description = _a.description, error = _a.error, colspans = _a.colspans, boundary = _a.boundary, ergoElements = _a.ergoElements, other = __rest(_a, ["className", "children", "label", "alignment", "tooltip", "description", "error", "colspans", "boundary", "ergoElements"]);
        var countChildren = React.Children.count(children);
        var spans;
        if (alignment === 'horizontal') {
            spans = this.state.colspans;
        }
        var componentClassName = classNames(className, 'ee_form-row', "ee_form-row--" + boundary, {
            'ee_is-invalid': Boolean(error)
        });
        var containerClassName = classNames('ee_form-row__container', "ee_form-row__container--" + boundary, {
            'ee_form-row__container--horizontal': alignment === 'horizontal',
            'ee_form-row__container--vertical': alignment === 'vertical',
            'ee_form-row__container--with-colspans': !!spans
        });
        var firstChild = React.Children.toArray(children)[0];
        var isFirstChildCompoundControl = React.isValidElement(firstChild)
            ? firstChild.type.isCompoundControl
            : false;
        var container = (React.createElement("div", { className: containerClassName }, React.Children.map(React.Children.toArray(children), function (child, index) {
            if (React.isValidElement(child)) {
                return _this.renderChild(child, alignment, spans, index);
            }
            return null;
        })));
        var messages = (error && typeof error !== 'boolean') || description ? (React.createElement("div", { className: classNames('ee_form-row__messages', "ee_form-row__messages--" + boundary) },
            error && (React.createElement("span", { role: "alert", className: "ee_form-row__hint" }, error)),
            !error &&
                description && (React.createElement("span", { className: "ee_form-row__hint" }, description)))) : null;
        var TooltipElement = tooltip_1.default('ee_form-row__tooltip-icon', tooltip);
        if (countChildren > 1 || isFirstChildCompoundControl) {
            var labelElement = typeof label === 'string' ? (React.createElement("span", { id: this.groupLabelId }, label)) : (React.cloneElement(label, { id: this.groupLabelId }));
            return (React.createElement("div", __assign({ role: "group", "aria-labelledby": this.groupLabelId }, other, { className: componentClassName }),
                React.createElement("div", { className: classNames('ee_form-row__descriptor', "ee_form-row__descriptor--" + boundary) },
                    labelElement,
                    TooltipElement),
                container,
                messages));
        }
        else {
            return (React.createElement("div", __assign({}, other, { className: componentClassName }),
                React.createElement("div", { className: classNames('ee_form-row__descriptor', "ee_form-row__descriptor--" + boundary) },
                    React.createElement("label", { htmlFor: this.id, className: "ee_form-row__label" }, label),
                    TooltipElement),
                container,
                messages));
        }
    };
    FormRowWithinContext.propTypes = propTypes;
    FormRowWithinContext.defaultProps = {
        label: undefined,
        tooltip: undefined,
        description: undefined,
        error: undefined,
        alignment: 'horizontal',
        colspans: undefined,
        boundary: 'wide',
        ergoElements: undefined
    };
    return FormRowWithinContext;
}(react_1.Component));
exports.FormRowWithinContext = FormRowWithinContext;
//# sourceMappingURL=FormRowWithinContext.js.map
